import { AppUseIcon } from "components/ui";

type UserDiagnosticsFileIndicatorProps = {
    iconName: string;
    containsFileType: boolean;
};

export const UserDiagnosticsFileIndicator = ({
    iconName,
    containsFileType
}: UserDiagnosticsFileIndicatorProps) => {

    return (
        <div className='d-flex align-items-start justify-content-between pt-2'>
            <AppUseIcon name={iconName} width='24' height='24' />
            {containsFileType
                ? (<AppUseIcon name='CheckMarkCircleIcon' width='24' height='24' />)
                : (<AppUseIcon name='CloseCircleIcon' width='24' height='24' />)
            }
        </div>
    );
};

export default UserDiagnosticsFileIndicator;